export default __webpack_public_path__ + "static/media/arrow-menu.9523590d.svg";